import { DefaultLinkService as DefaultLinkServiceFromRouter } from '@spryker-oryx/router';

/**
 * @deprecated since 1.4, use DefaultLinkService from @spryker-oryx/router instead
 */
export class DefaultLinkService extends DefaultLinkServiceFromRouter {}
